/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Tabs, Paper, Tab, Button, Typography } from "@material-ui/core";

const styles = theme => ({
  text: {
    textAlign: "center",
    fontSize: 20,
    padding: "2%",
    paddingLeft: "20%",
    paddingRight: "20%",
    maxHeight: 300,
    overflow: "auto"
  },
  bigTab: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  smallTab: {
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "none"
    }
  },
  tab: {
    fontSize: 16
  },
  center: {
    textAlign: "center",
  },
  panel: {
    position: "fixed",
    width: "100%",
    bottom: 100,
    left: 0
  },
  button: {
    margin: 5,
    color:"white"
  }
});

class ExplanationPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      panel: 0,
      show: true
    };
    this.handleChangePanel = this.handleChangePanel.bind(this);
    this.toggleExplanation = this.toggleExplanation.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.matrixExplanation !== this.props.matrixExplanation) {
      if (this.props.matrixExplanation)
        this.setState({
          show: true,
          panel: 2
        });
      else
        this.setState({
          show: true,
          panel: 0
        });
    }
  }

  toggleExplanation() {
    this.setState(prevState => ({
      show: !prevState.show
    }));
  }

  handleChangePanel = (event, value) => {
    this.setState({ panel: value });
  };

  render() {
    const { classes } = this.props;
  console.log(this.props)
    return (
      <div className={classes.center}>
        {!this.state.show && (
          <Paper className={classes.panel}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.toggleExplanation}
              className={classes.button}
            >
              {
                this.props.language.labels[this.props.language.id]
                  .explanationShowButton
              }
            </Button>
          </Paper>
        )}
        {this.state.show && (
          <Paper className={classes.panel}>
            <Tabs
              className={classes.bigTab}
              value={this.state.panel}
              onChange={this.handleChangePanel}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab
                className={classes.tab}
                label={
                  this.props.language.labels[this.props.language.id]
                    .globalExplanation
                }
              />
              <Tab
                className={classes.tab}
                label={
                  this.props.language.labels[this.props.language.id]
                    .localExplanation
                }
              />
              {this.props.matrixExplanation && (
                <Tab
                  className={classes.tab}
                  label={
                    this.props.language.labels[this.props.language.id]
                      .matrixExplanation
                  }
                />
              )}
            </Tabs>
            <Tabs
              className={classes.smallTab}
              value={this.state.panel}
              onChange={this.handleChangePanel}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab
                className={classes.tab}
                label={
                  this.props.language.labels[this.props.language.id].globalExplanation
                }
              />
              <Tab
                className={classes.tab}
                label={this.props.language.labels[this.props.language.id].localExplanation}
              />
              {this.props.matrixExplanation && (
                <Tab
                  className={classes.tab}
                  label={
                    this.props.language.labels[this.props.language.id].matrix
                  }
                />
              )}
            </Tabs>
            <Typography className={classes.text}>
              {this.state.panel === 0 && this.props.globalExplanation
                ? this.props.globalExplanation.map(item => {
                    return item + " ";
                  })
                : ""}
              {this.state.panel === 1 && this.props.localExplanation
                ? this.props.localExplanation.map(item => {
                    return item + " ";
                  })
                : ""}
              {this.state.panel === 1 &&
                !this.props.localExplanation &&
                this.props.language.labels[this.props.language.id].localEmpty}
              {console.log(this.props.matrixExplanation)}
              {this.state.panel === 2 && this.props.matrixExplanation
                ? this.props.matrixExplanation===true ? this.props.language.labels[this.props.language.id].matrixExplanationContent : this.props.matrixExplanation[0]
                : ""}
            </Typography>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={this.toggleExplanation}
            >
              {
                this.props.language.labels[this.props.language.id]
                  .explanationHideButton
              }
            </Button>
          </Paper>
        )}
      </div>
    );
  }
}

ExplanationPanel.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ExplanationPanel);
